<template>
  <header>
    <div class="nav">
      <div class="nav-content">
        <div class="dis-flex">
          <!-- system label -->
          <div class="system_label">{{ $t('gpsTracker.header.title') }}</div>
        </div>
        <div class="dis-flex">
          <!-- ユーザー情報 -->
          <div class="tti-user">
            <el-popover :close-delay="0" trigger="hover" :visible-arrow="false" popper-class="menu-popper">
              <div
                class="menu-items-child"
                @click="onUpdatePassword"
                v-tooltip="{
                  content: `${$t('headerMenu.updatepasswordTip')}`,
                  placement: 'bottom-start',
                  delay: { show: 1000, hide: 0 }
                }"
              >
                <tti-svg-icon icon-name="wo_009"></tti-svg-icon>
                <span class="tti-user-text">{{ $t('headerMenu.updatePassword') }}</span>
              </div>
              <div
                class="menu-items-child"
                @click="onLogout"
                v-tooltip="{
                  content: `${$t('headerMenu.loginoutTip')}`,
                  placement: 'bottom-start',
                  delay: { show: 1000, hide: 0 }
                }"
              >
                <tti-svg-icon icon-name="su_001"></tti-svg-icon>
                <span class="tti-user-text">{{ $t('headerMenu.loginout') }}</span>
              </div>
              <el-avatar size="medium" class="cursor-pointer" icon="el-icon-user-solid" slot="reference"></el-avatar>
            </el-popover>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'

import { dialog } from '@/store/modules'
import config from '@/config/config'
import { postLogout } from '@/store/apis'
import { clearLocal, clearSession } from '@/commons/services/localService'
import HelperService from '@/service/helperService'
import { msgBoxService } from '@/commons/services/msgBoxService'
import { i18n } from '@/locales'
import { moveService } from '@/commons/services/moveService'
import { clearWindowCookie } from '@/service/refreshAndCloseWindowService'

@Component({
  name: 'TrackerRegisterHeader'
})
export default class TrackerRegisterHeader extends Vue {
  /**
   * インスタンスがマウントされたちょうど後にフック処理
   *
   * @returns {void}
   */
  mounted(): void {
    this.$log.debug('TrackerRegisterHeader > mounted')
  }

  /**
   * パスワード変更の表示状態を切り替
   *
   * @returns {void}
   */
  onUpdatePassword(): void {
    this.$log.debug('TrackerRegisterHeader > onUpdatePassword')
    dialog.setUpdatePsIsShow()
  }

  /**
   * ログアウト
   *
   * @returns {void}
   */
  onLogout(): void {
    const confirmCallback = async () => {
      await moveService.beforeLogout()
      this.doLogout()
    }

    msgBoxService.confirm(i18n.t('messages.logoutGPSTrackerConfirm').toString(), confirmCallback)
  }

  /**
   * ログアウトを実行する。
   *
   * @returns {void}
   */
  async doLogout(): Promise<void> {
    try {
      await postLogout()
      clearLocal()
      clearSession()
      HelperService.removeAccessToken()
      clearWindowCookie()
      Vue.nextTick(() => {
        this.$router.push(config.menu.login)
      })
    } catch (e) {
      Vue.$log.debug('Login > onLogout: e=', e)
      throw e
    }
  }
}
</script>

<style scoped lang="scss">
.nav {
  height: 48px;
  overflow: hidden;
  box-sizing: border-box;
}

.nav-content {
  padding: 4px 12px;
  display: flex;
  justify-content: space-between;
}

.dis-flex {
  display: flex;
  align-items: center;
}

.system_label {
  font-size: 24px;
  font-style: italic;
}

.tti-user {
  margin-left: 32px;
  display: flex;
  align-items: center;
}

.menu-items-child {
  height: 40px;
  padding: 0 12px;
  display: flex;
  align-items: center;

  &:hover {
    cursor: pointer;
    color: #409eff;
    border-color: #c6e2ff;
    background-color: rgba(102, 128, 238, 0.15);
  }
}

.tti-user-text {
  padding-left: 6px;
}

.cursor-pointer {
  cursor: pointer;
}
</style>

<style lang="scss">
/* ポップオーバーはスタイルの変更 */
.menu-popper {
  padding: 0;
  margin-top: 6px !important;
}

.selectOfficeHeight {
  max-height: 500px;
  overflow: auto;
}
</style>
